import { ListChecks } from 'lucide-react';
import { cn } from '@/lib/utils';
import type { ChecklistProgress } from '@/lib/checklists';

interface ChecklistProgressBadgeProps {
  progress: ChecklistProgress | null | undefined;
  className?: string;
  testId?: string;
}

/** Compact "12/15" checklist progress for job cards. Renders nothing without a checklist. */
export function ChecklistProgressBadge({ progress, className, testId }: ChecklistProgressBadgeProps) {
  if (!progress || progress.total === 0) return null;
  return (
    <span
      data-testid={testId}
      title={`Checklist: ${progress.done} of ${progress.total} done`}
      aria-label={`Checklist ${progress.done} of ${progress.total} done`}
      className={cn(
        'inline-flex shrink-0 items-center gap-1 rounded-md px-1.5 py-0.5 text-[10.5px] font-semibold tabular-nums',
        progress.complete
          ? 'bg-emerald-500/15 text-emerald-700 dark:text-emerald-300'
          : 'bg-muted text-muted-foreground',
        className,
      )}
    >
      <ListChecks className="h-3 w-3" aria-hidden="true" />
      {progress.label}
    </span>
  );
}
